(() => {
  if (window.topKippahInquiriesReady) return;
  window.topKippahInquiriesReady = true;
  const context = document.getElementById('tk-inquiry-context');
  const product = context?.dataset.productTitle || '';
  const productUrl = context?.dataset.productUrl || '';
  const whatsappCopy = JSON.parse(document.getElementById('tk-whatsapp-copy')?.textContent || '{}');
  const params = new URLSearchParams(window.location.search);
  const requestedProduct = params.get('product')?.slice(0, 240) || '';
  const safeProductUrl = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && /^\/(?:fr\/)?products\/[^/]+$/.test(url.pathname)
        ? url.origin + url.pathname : '';
    } catch { return ''; }
  };
  const requestedUrl = safeProductUrl(params.get('product_url'));
  const prepareLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      if (product && url.origin === window.location.origin && /\/pages\/request-a-quote$/.test(url.pathname)) {
        url.searchParams.set('product', product);
        url.searchParams.set('product_url', productUrl);
        link.href = url.toString();
      }
      if (url.hostname === 'wa.me' && url.pathname === '/8615914047809' && !url.searchParams.has('text')) {
        const title = product || requestedProduct;
        const reference = productUrl || requestedUrl;
        const lines = [title ? whatsappCopy.product.replace('%{title}', title) : whatsappCopy.general];
        if (reference) lines.push(reference);
        lines.push(whatsappCopy.quantity, whatsappCopy.event, whatsappCopy.country, whatsappCopy.fabric);
        url.searchParams.set('text', lines.join('\n'));
        link.href = url.toString();
      }
    });
  };
  const prepareQuote = () => {
    const form = document.getElementById('TopKippahQuote');
    if (!form || form.dataset.contextReady) return;
    form.dataset.contextReady = 'true';
    if (requestedUrl && !form.querySelector('#tk-reference').value) form.querySelector('#tk-reference').value = requestedUrl;
    if (requestedProduct && !form.querySelector('#tk-notes').value) form.querySelector('#tk-notes').value = [requestedProduct, requestedUrl].filter(Boolean).join('\n');
  };
  const publish = (name, extra = {}) => {
    const shopify = window.Shopify;
    if (shopify?.designMode || !shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (!shopify?.analytics?.publish) return;
    try {
      const result = shopify.analytics.publish(`topkippah:${name}`, {
        page_path: window.location.pathname,
        product_id: context?.dataset.productId || '',
        product_handle: productUrl ? new URL(productUrl).pathname.split('/').pop() : '',
        collection_handle: context?.dataset.collectionHandle || '',
        ...extra
      });
      if (result?.catch) result.catch(() => {});
    } catch { /* An analytics error must never interrupt an inquiry. */ }
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.origin);
    if (url.hostname === 'wa.me' && url.pathname === '/8615914047809') publish('whatsapp_click');
    else if (url.origin === window.location.origin && /\/pages\/request-a-quote$/.test(url.pathname)) publish('quote_open');
    else if (url.origin === window.location.origin && /\/products\/custom-kippah-sample$/.test(url.pathname)) publish('sample_open');
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (form.id === 'TopKippahQuote' && form.checkValidity()) publish('quote_submit');
  });
  const setup = () => {
    prepareLinks(); prepareQuote();
    const success = document.querySelector('#TopKippahQuote [data-quote-success]');
    if (success && !success.dataset.eventReported) {
      success.dataset.eventReported = 'true';
      publish('quote_success');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
